/* Shopify calcula uma cotação isolada para os mesmos SKUs usados pelo configurador.
   Nenhuma chamada à API AJAX do carrinho, identificação pessoal ou checkout. */
(function () {
  if (customElements.get('damie-frete-produto')) return
  var query = 'mutation FreightEstimate($input: CartInput!) { cartCreate(input: $input) { cart { lines(first: 100) { nodes { quantity merchandise { ... on ProductVariant { id } } } pageInfo { hasNextPage } } deliveryGroups(first: 10) { nodes { deliveryOptions { title description deliveryMethodType estimatedCost { amount currencyCode } } } pageInfo { hasNextPage } } } userErrors { field message } } }'
  var cache = new Map()

  class DamieFreteProduto extends HTMLElement {
    static get observedAttributes() { return ['data-items'] }
    connectedCallback() {
      if (this.state) return
      this.state = this.querySelector('[data-frete-state]')
      this.result = this.querySelector('[data-frete-result]')
      this.heading = this.querySelector('[data-frete-title]')
      this.help = this.querySelector('[data-frete-help]')
      this.state.onchange = () => this.schedule()
      this.resize = new ResizeObserver(() => {
        var root = this.closest('[id^="dc-"]')
        if (root && this.offsetHeight) root.style.setProperty('--damie-frete-height', (this.offsetHeight + 10) + 'px')
      })
      this.resize.observe(this)
    }
    disconnectedCallback() {
      clearTimeout(this.timer)
      if (this.controller) this.controller.abort()
      if (this.resize) this.resize.disconnect()
      this.state = null
    }
    attributeChangedCallback() { if (this.state) this.schedule() }
    schedule() {
      clearTimeout(this.timer)
      this.revision = (this.revision || 0) + 1
      if (this.controller) this.controller.abort()
      this.help.hidden = true
      if (!this.state.value) {
        this.heading.textContent = 'Frete grátis e entrega rápida'
        this.result.textContent = 'Selecione o estado para consultar o prazo e as condições de frete.'
        return
      }
      this.heading.textContent = 'Consultando sua entrega'
      this.result.textContent = 'Buscando prazo e frete para a configuração selecionada…'
      this.timer = setTimeout(() => this.quote(this.revision), 350)
    }
    async quote(revision) {
      var controller = new AbortController()
      this.controller = controller
      var timeout = setTimeout(() => controller.abort(), 12000)
      try {
        var items = JSON.parse(this.dataset.items || '[]')
        if (!items.length) throw new Error('no variant')
        var key = this.state.value + ':' + JSON.stringify(items)
        var hit = cache.get(key)
        var groups
        if (hit && Date.now() - hit.time < 60000) groups = hit.groups
        else {
          var response = await fetch('/api/2026-07/graphql.json', {
            method: 'POST', credentials: 'omit', signal: controller.signal,
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ query: query, variables: { input: {
              buyerIdentity: { countryCode: 'BR' },
              lines: items.map(item => ({ merchandiseId: 'gid://shopify/ProductVariant/' + item.id, quantity: item.quantity })),
              delivery: { addresses: [{ selected: true, oneTimeUse: true,
                address: { deliveryAddress: { countryCode: 'BR', provinceCode: this.state.value } } }] }
            } } })
          })
          if (!response.ok) throw new Error('shipping response')
          var data = await response.json()
          var payload = data.data && data.data.cartCreate
          if (data.errors || !payload || payload.userErrors.length || !payload.cart || payload.cart.deliveryGroups.pageInfo.hasNextPage) throw new Error('shipping unavailable')
          groups = payload.cart.deliveryGroups.nodes
          if (groups.length) {
            if (payload.cart.lines.pageInfo.hasNextPage) throw new Error('incomplete items')
            var requested = new Map()
            items.forEach(item => {
              var id = 'gid://shopify/ProductVariant/' + item.id
              requested.set(id, (requested.get(id) || 0) + item.quantity)
            })
            payload.cart.lines.nodes.forEach(line => {
              var id = line.merchandise.id
              requested.set(id, (requested.get(id) || 0) - line.quantity)
            })
            if (Array.from(requested.values()).some(quantity => quantity !== 0)) throw new Error('items changed')
          }
          cache.set(key, { time: Date.now(), groups: groups })
          if (cache.size > 30) cache.delete(cache.keys().next().value)
        }
        if (revision !== this.revision) return
        var options = groups.map(group => group.deliveryOptions
          .filter(option => option.deliveryMethodType === 'SHIPPING')
          .sort((a, b) => Number(a.estimatedCost.amount) - Number(b.estimatedCost.amount))[0])
        if (!options.length || options.some(option => !option)) {
          this.heading.textContent = 'Consulte entrega para sua região'
          this.result.textContent = 'Não encontramos uma opção de frete para este estado. Fale com o vendedor para verificar o atendimento.'
          this.help.hidden = false
          return
        }
        var currency = options[0].estimatedCost.currencyCode
        if (options.some(option => option.estimatedCost.currencyCode !== currency)) throw new Error('currency')
        var total = options.reduce((sum, option) => sum + Number(option.estimatedCost.amount), 0)
        if (!Number.isFinite(total)) throw new Error('shipping price')
        var deadlines = options.map(option => {
          var text = (option.title || '') + ' ' + (option.description || '')
          var range = text.match(/(\d+)\s*(?:a|até|[-–—])\s*(\d+)\s*dias?\s*(úteis|uteis|corridos)?/i)
          var single = text.match(/(?:até\s*)?(\d+)\s*dias?\s*(úteis|uteis|corridos)?/i)
          return range ? { min: Number(range[1]), max: Number(range[2]), unit: range[3] || 'dias' }
            : single ? { min: Number(single[1]), max: Number(single[1]), unit: single[2] || 'dias' } : null
        })
        var deadline = ''
        if (deadlines.every(d => d && d.unit === deadlines[0].unit)) {
          var min = Math.max.apply(null, deadlines.map(d => d.min))
          var max = Math.max.apply(null, deadlines.map(d => d.max))
          var unit = deadlines[0].unit === 'dias' ? '' : ' ' + deadlines[0].unit.replace('uteis', 'úteis')
          deadline = (min === max ? 'Em até ' + max : 'Em ' + min + ' a ' + max) + ' dias' + unit
        }
        this.heading.textContent = total === 0 ? 'Frete grátis e entrega rápida' : 'Entrega para seu estado'
        var strong = document.createElement('strong')
        strong.textContent = total === 0 ? 'Frete grátis' : 'Frete: ' + new Intl.NumberFormat('pt-BR', { style: 'currency', currency: currency }).format(total)
        if (deadline) strong.textContent += ' · ' + deadline
        this.result.replaceChildren(strong, document.createTextNode(deadline
          ? 'Transportadora especializada em móveis'
          : 'Prazo não informado na tabela de frete. Consulte o vendedor.'))
        this.help.hidden = Boolean(deadline)
      } catch (error) {
        if (revision !== this.revision) return
        this.heading.textContent = 'Consulte sua entrega'
        this.result.textContent = 'Não foi possível consultar agora. Tente novamente ou fale com o vendedor.'
        this.help.hidden = false
      } finally { clearTimeout(timeout) }
    }
  }
  customElements.define('damie-frete-produto', DamieFreteProduto)
})()
